export const ERR_APP_EXISTS = 'TOOLPAD_APP_EXISTS';
export const ERR_VALIDATE_CAPTCHA_FAILED = 'TOOLPAD_VALIDATE_CAPTCHA_FAILED';
